import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  readonly showOverlay = this.loader.isLoading;

  constructor(
    private loader: LoaderService
  ) { }

}
